<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    太安站<br>
站点介绍<br>
太安站是是5号线和7号线的换乘站，车站位于东晓路与布心路交叉口处，横跨太安路、布心路，止于太白路。主体沿东晓路呈南北走向。车站周围有永旺、喜荟城、五方装饰材料市场等大型购物中心。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:19	23:08	5号线	3分钟	5分25秒<br>
黄贝岭	06:09	00:13	5号线	3分钟	5分25秒<br>
西丽湖	06:20	23:00	7号线	3分35秒	5分55秒<br>
太安	--	--	7号线	3分35秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:25	23:08	5号线	4分钟	6分钟<br>
黄贝岭	06:21	00:13	5号线	4分钟	6分钟<br>
西丽湖	06:19	23:00	7号线	4分钟	5分55秒<br>
太安	--	--	7号线	4分钟	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:25	00:08	5号线	4分钟	6分钟<br>
黄贝岭	06:21	01:13	5号线	4分钟	6分钟<br>
西丽湖	06:20	00:00	7号线	4分钟	5分55秒<br>
太安	--	--	7号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A出入口:<br>
东晓路西侧、布心路南侧（西）、深圳市职业病防治院、深圳市慢性病防治中心、深圳市公安局罗湖区公安分局翠竹派出所<br><br>
B出入口:<br>
太安路西侧、百仕达小学、东湖中学、粤海新村、百仕达花园、百仕达二期<br><br>
C出入口:<br>
东晓路东侧、太安路东侧、水库小学、东乐花园、东安花园<br><br>
D出入口:<br>
布心路东侧<br><br>
E出入口:<br>
粤海城、布心路北侧、布心小学、罗湖区妇幼保健院、深圳市公安局罗湖区公安分局东湖派出所<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 市慢性病防治院<br>
23、308、376、M140（原B840）、高峰专线97<br><br>
E出入口:<br>
公交站名： 布心花园<br>
23、308、M140（原B840）、高峰专线97<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "qihaoxian",
          title: "7号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


